import moment from 'moment'

export default {
	methods: {
		regraObrigatoriedade(value, message) {
			if (typeof value === 'string') {
				return (!!value && value.trim().length > 0) || message
			}

			return !!value || message
		},
		regraDeTamanhoMaximoString(value, maxLength, message) {
			return (!!value && value.length <= maxLength) || message
		},
		regraValidarDataMaiorQueAtual(value, message) {
			return (!!value && moment(value).date() === moment.now()) || message
		},
		valorPrecisaSerMaiorQueZero(value, message) {
			return (!!value && value > 0) || message
		},
	},
}
